import React, { useState } from 'react';
import { Card, Container } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';

const CategoryCard = ({ data }) => {
    const navigate = useNavigate();
    const [isHovered, setIsHovered] = useState(false);

    const handleCardClick = (category) => {
        navigate(`/category/${category}`);
    };

    return (
        <Container
            className="m-4"
            onClick={() => handleCardClick(data.categoryString)}
            style={{ cursor: 'pointer' }}
        >
            <Card
                className="border shadow-sm"
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}
                style={{
                    borderRadius: '10px',
                    position: 'relative',
                    width: 'auto',
                    backgroundColor: '#f8f9fa',
                    border: `2px solid ${isHovered ? '#8d070e' : '#ccc'}`,
                    transition: 'all 0.3s ease-in-out',
                    transform: isHovered ? 'scale(1.05)' : 'scale(1)',
                    boxShadow: isHovered
                        ? '0px 8px 20px rgba(141, 7, 14, 0.4)'
                        : '0px 2px 5px rgba(0, 0, 0, 0.1)',
                }}
            >
                {/* Badge in top-right corner */}
                <div
                    style={{
                        position: 'absolute',
                        top: '-15px',
                        right: '10px',
                        margin: '0.1rem',
                        zIndex: 1,
                    }}
                >
                    <span
                        className="badge"
                        style={{
                            backgroundColor: isHovered ? '#6d050b' : '#8d070e',
                            color: 'white',
                            borderRadius: '5px',
                            padding: '0.5rem',
                            transition: 'background 0.3s ease-in-out',
                        }}
                    >
                        TERPOPULER
                    </span>
                </div>

                <Card.Body>
                    <Card.Title
                        className="fw-bold"
                        style={{
                            color: isHovered ? "#8d070e" : "black",
                            transition: "color 0.3s ease-in-out",
                        }}
                    >
                        Kategori Layanan
                    </Card.Title>
                    <Card.Subtitle className="mb-2 text-muted">
                        {data.categoryString || <span style={{ opacity: 0.3 }}>Kategori</span>}
                    </Card.Subtitle>
                    <Card.Text
                        style={{
                            color: isHovered ? "#8d070e" : "#6c757d",
                            transition: "color 0.3s ease-in-out",
                        }}
                    >
                        {data.count} Layanan
                    </Card.Text>
                </Card.Body>
            </Card>
        </Container>
    );
};

export default CategoryCard;
